<template>
  <div id="nosso-canal" class="canal-youtube">
    <section class="container">
      <h1>Inclusão Na Lata</h1>
      <p>O "Inclusão na Lata" (INL) é o nosso canal no YouTube para falar sobre acessibilidade sem floreios, sem frescuras, na lata mesmo!   O nosso canal tem Legenda?    Tem sim senhor! O nosso canal tem Libras? Tem sim senhor! O nosso canal tem Audiodescrição? Tem sim senhor! É assim que a gente do Inclusão na Lata vai falar de inclusão e acessibilidade com vocês.  <strong>Assista ao nosso último vídeo:</strong></p>
    </section>
    <section class="container">

      <article class="videos">
        <b-embed type="iframe"
                aspect="16by9"
                src="https://www.youtube.com/embed/OfwpMU4CM4o"
                allowfullscreen
        ></b-embed>
      </article>

      <div class="btn-center">
        <a href="#" class="btn-orange">Confira mais vídeos no canal</a>
      </div>

    </section>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  data () {
    return {
      msg: 'Incluir da Certo'
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~styles/_bootstrap-variables";
  @import "~styles/_mixin-buttons";
  @import "~styles/_main";
  @import "~styles/_canal-youtube";
</style>



// WEBPACK FOOTER //
// src/components/CanalYoutube.vue